module.exports = __webpack_public_path__ + "static/media/cyrex-video-placeholder-1.32b2091b.png";